// extracted by mini-css-extract-plugin
export default {"box":"box__RivH1","profile":"profile__lId0C","alert":"alert__Qrsyk","badge":"badge__qVEJO","red":"red__jRHSx","yellow":"yellow__X2yFJ","green":"green__OeJ4n"};